import type { WorkLedgerRow } from './work-ledger-port';

export function workLocalDate(value: string | number = Date.now()): string {
  const time = typeof value === 'number' ? value : Date.parse(value);
  return Number.isFinite(time) ? new Date(time + 9 * 3600_000).toISOString().slice(0, 10) : '';
}
export function shiftWorkDate(value: string, offset: number): string {
  const time = Date.parse(`${value}T00:00:00Z`);
  return Number.isFinite(time) ? new Date(time + offset * 86400_000).toISOString().slice(0, 10) : value;
}
export type DailyWorkRow = { row: WorkLedgerRow; date: string; status: string; group: string; patrol: string; closeout: string };
export function workRegisterRows(rows:readonly WorkLedgerRow[],from:string,to:string,mode:string){
 const seen=new Set<string>();
 return dailyWorkRows(rows,from,to).filter(value=>{
  if(mode!=='전체 대장'||!value.row.imported)return true;
  if(seen.has(value.row.workId))return false;
  seen.add(value.row.workId);return true;
 });
}
export function dailyWorkRows(rows: readonly WorkLedgerRow[], from: string, to: string, today = workLocalDate()): DailyWorkRow[] {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(from) || !/^\d{4}-\d{2}-\d{2}$/.test(to) || from > to) return [];
  const dayCount = (Date.parse(to) - Date.parse(from)) / 86400_000;
  if (!Number.isFinite(dayCount) || dayCount > 366) return [];
  return rows.flatMap(row => {
    const start = workLocalDate(row.startsAt), end = workLocalDate(row.endsAt);
    if (!start || !end) return [];
    const evidence = row.register?.dailyEvidence;
    const completed = evidence?.completedAt ? workLocalDate(evidence.completedAt) : '';
    const result: DailyWorkRow[] = [];
    for (let date = start > from ? start : from; date <= end && date <= to; date = shiftWorkDate(date, 1)) {
      // No planned daily activity after an authoritative final closeout.
      if (completed && date > completed) continue;
      const imported=row.imported;
      if(imported){
        if(imported.dateSpec.kind==='dates'&&!imported.dateSpec.dates.includes(date))continue;
        result.push({row,date,group:imported.status==='작업종료'?'완료':imported.status==='작업취소'?'무효':'예정',
          status:imported.status,patrol:'—',closeout:'—'});
        continue;
      }
      const patrols = evidence?.patrols.filter(p => workLocalDate(p.at) === date) ?? [];
      const unresolved = patrols.filter(p => p.actionRequired && (!p.resolvedAt || workLocalDate(p.resolvedAt) > date)).length;
      const day = row.register?.days?.[date];
      const ended = completed === date || !!day?.closedAt;
      const started = evidence?.startedAt && workLocalDate(evidence.startedAt) === date;
      const stopped = row.lifecycle === 'suspended' && date === today;
      let group = ended ? '완료' : patrols.length || started || day?.attendees ? '진행' : date >= today ? '예정' : '기록 없음';
      if (row.lifecycle === 'invalidated') group = '무효';
      result.push({row, date, group, status: stopped ? '작업 중지' : group,
        patrol: evidence ? patrols.length ? `${patrols.length}회 · ${unresolved ? '조치 확인' : '이상 없음'}` : '—' : '조회 필요',
        closeout: ended ? '완료' : '—'});
    }
    return result;
  }).sort((a,b) => a.date.localeCompare(b.date) || a.row.title.localeCompare(b.row.title,'ko'));
}
